<template>
  <div class="logout">
    <v-switch
      @change="autoScroll"
      v-model="scroll"
      label="AutoScroll"
    ></v-switch>
    <div class="link-outer" @click="onDashboard()">
      <router-link to="/" class="logout-btn" :class="{'_disabled': !isActiveBoard}">Dashboard</router-link>
    </div>
    <button @click="logout" class="logout-btn">Log Out</button>
    <button @click="fullScreen" class="fs-btn" title="Toggle Fullscreen Mode">
      <i class="mdi" :class="isFullScreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'"></i>
    </button>
  </div>
</template>


<script>
import { getCookie } from "@/main";
import { mapMutations } from 'vuex';

export default {
  name: "logout",
  data() {
    return {
      scroll: getCookie("scroll") == "true" ? true : false,
      mouseoverTimeout: false,
      isFullScreen: false,
    };
  },
  computed: {
    isActiveBoard() {
      return this.$store.state.boards.active;
    }
  },
  methods: {
    ...mapMutations({
      removeActiveBoard: 'boards/removeActiveBoard'
    }),
    onDashboard() {
      this.removeActiveBoard();
    },
    autoScroll($event) {
      this.scroll = $event;
      document.cookie =
        "scroll=" + $event + "; path=/; expires=Tue, 1 Jan 2049 04:20:00 GMT";
      this.$variables.autoScroll = $event;
    },
    logout() {
      this.$store.dispatch("app/authLogout");
      this.$router.push({ name: "login" });
    },
    fullScreen() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
        this.isFullScreen = false;
      } else {
        document.documentElement.requestFullscreen();
        this.isFullScreen = true;
      }
    }
  },
};
</script>


<style lang="scss">
.logout {
  position: fixed;
  bottom: 0;
  padding: 20px;
  right: 0;
  z-index: 10000;
  align-items: center;
  border-bottom: 4px solid #fff;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  
  opacity: 0;
  transition: opacity 0.2s ease 2s;
  &:hover {
    opacity: 1;
    transition: opacity 0.2s ease 0s;
  } 
  
  .v-messages {
    display: none !important;
  }
  .v-input {
    margin: 0;
  }
  .v-input__slot {
    margin: 0;
  }
}
.link-outer {
  display: flex;
  margin: 0 0 0 20px;
  .logout-btn {
    margin: 0;
  }
}
.logout-btn {
  color: #fff !important;
  text-decoration: none;
  margin-left: 20px;
  background: #c2185b;
  border-radius: 10px;
  padding: 7px 17px;
  transition: 0.2s;
  &:hover {
    opacity: 0.5;
  }
  &._disabled {
    background-color: #b2b2b2;
    pointer-events: none;
  }
}
.fs-btn {
  margin-left: 20px;
  width: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  .mdi {
    font-size: 38px;
    line-height: 1;
  }
}

</style>